import { Box, Stack, Typography } from '@mui/material';
import type { LiveStatus } from '../lib/useLive';

const LOOK: Record<LiveStatus, { color: string; text: string }> = {
  connecting: { color: 'text.secondary', text: 'Connecting…' },
  live: { color: 'success.main', text: 'Live' },
  reconnecting: { color: 'error.main', text: 'Reconnecting…' },
};

export function LiveIndicator({ status }: { status: LiveStatus }) {
  const look = LOOK[status];
  return (
    <Stack direction="row" spacing={0.75} sx={{ alignItems: 'center' }}>
      <Box sx={{ width: 9, height: 9, borderRadius: '50%', bgcolor: look.color }} />
      <Typography variant="caption" color="text.secondary">
        {look.text}
      </Typography>
    </Stack>
  );
}
